var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-solutions"},[_c('header-main',_vm._b({},'header-main',_vm.$props,false)),_vm._v(" "),_c('div',{ref:"triggerSticky"}),_vm._v(" "),(_vm.showSticky)?_c('div',{staticClass:"sticky"},[_c('header-sticky',_vm._b({},'header-sticky',_vm.$props,false))],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }